export enum PRIVACY_POLICY_STATUS {
  APPROVED = 'APPROVED',
  OPEN = 'OPEN',
  ERROR = 'ERROR',
}
